<template>
  <div class="okv-ai-sidebar">
    <b-sidebar
      id="ai-sidebar"
      sidebar-class="border-ai-bar"
      bg-variant="white"
      no-header
      no-header-close
      right
      v-model="_visible"
      z-index="1500"
      :width="_fullWidth"
      backdrop
    >
      <chat-widget
        v-if="_visible"
        :title="$t('navbar.aiAssistant')"
        :locale="$i18n.locale"
        :domain="getDomain"
        :tenant="getTenant"
        :context="getContext"
        :userId="getUserId"
        roleId="1"
        company="fairmat"
        :token="getToken"
        :suggestedMessage="getSuggestedMessage"
        @expand="isFullScreen = !isFullScreen"
        @close="onCloseAiSidebar"
      ></chat-widget>
    </b-sidebar>
  </div>
</template>

<script>
import { getUserInfo } from '@/plugins/authentication'

export default {
  name: 'AiSidebar',
  components: {},
  props: {
    visible: Boolean,
    barWidth: {
      type: String,
      default: '700px',
    },
  },

  watch: {
    visible(newValue, oldValue) {
      if (oldValue === true && newValue === false) {
        this.dropdownOpen = false
        this.isFullScreen = false
      }
    },
  },

  data() {
    return {
      isFullScreen: false,
      dropdownOpen: false,
      conversationId: null,
      conversationList: [],
      loadingResponse: false,
      loadingConversationList: false,
      firstLoading: false,
      tokenValue: window.localStorage.getItem('okv-token'),
    }
  },
  computed: {
    _visible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
    _fullWidth() {
      return this.isFullScreen ? '100%' : this.barWidth
    },
    getDomain() {
      return 'home'
    },
    getTenant() {
      return 'fairmat'
    },
    getContext() {
      return 'okv'
    },
    getToken() {
      return this.tokenValue
    },
    getSuggestedMessage(){
      return JSON.stringify([
        'Seleziona i prodotti di ramo I',
        'Seleziona i prodotti con RIY a RHP superiore al 3%',
        'Cosa significa RHP?'
      ]);
    },
    getUserId() {
      const info = JSON.parse(getUserInfo())
      return this.usernameToInt(info.username)
    },
  },
  methods: {
    onCloseAiSidebar() {
      this._visible = false
    },
    getTime(data) {
      let result = data
      if (result) {
        return isoStringDateToLocaleWithLocalOffset({ isoStringDate: result, language: 'it-IT', withTime: true })
      }
      return result
    },
    getDateWithoutOffset() {
      const offsetHours = getLocalOffsetHours()
      let newDate = new Date(new Date().getTime() - offsetHours * 60 * 60 * 1000)
      return newDate
    },
    headerClick(value) {
      // todo
    },
    usernameToInt(username) {
      let hash = 0x811c9dc5
      for (let i = 0; i < username.length; i++) {
        hash ^= username.charCodeAt(i)
        hash = Math.imul(hash, 0x01000193)
      }
      return hash >>> 0
    },
    onAccessTokenUpdated(newToken) {
      this.tokenValue = newToken
    },
  },
  created() {
    this.$bus.$on('access-token-updated', this.onAccessTokenUpdated)
  },
  beforeDestroy() {
    this.$bus.$off('access-token-updated', this.onAccessTokenUpdated)
  },
  async mounted() {
  },
}
</script>

<style lang="scss">
chat-widget {
  --q-primary: #ea633e;
  --q-secondary: #3e3e3e;
  --q-font-family: Helvetica;
  --headerBackground: #2e2e2e;
  --logoBackground: #242424;
  --headerColor: #fff;
  --headerColorInputSearch: #0000008a;
  --filterLabelColors: inherit;
  --rowOddBackground: #f2f2f2;
  --muted: $muted;
  --black: $black;
  --text-light: #ffffff;
  --darkStyle: #2f2f2f;
  --darkGreyStyle: #7f7f7f;
  --greyStyle: #c5c5c5;
  --lightGreyStyle: #ececec;
  --lightRedStyle: #ed6e6b;
  --headerGradientColor: #9d2121;
  --header-height: 80px;
  --header-height-mobile: 100px;
  --height-sidebar-header: 50px;
  --aicolor-start: #c5281c;
  --aicolor-end: #412ae8;
}
</style>
